import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../../common_components/Header";
import DatePicker from "react-datepicker";
import Footer from "../../common_components/Footer";
import Drawer from "../../common_components/Drawer";
import {
    getUserHotelEnquiry_action,
    insertHotelEnquiry_action
} from "../../actions/exhibitor_module_actions/hotel_form_action/hotel_form_action";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import HeaderLogin from '../../common_components/HeaderLogin';
import { ToastContainer, toast } from "react-toastify";
import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../utils/withRouter";
import moment from "moment";
import Modal from "react-modal";
import Loader from "../../utils/Loader";
import {
    clearSessionStorage,
    countryActionId,
    stateActionId,
    cityActionId,
    pincodeActionId,
    verifyPrimaryEmailIDActionId,
    toastError, GSTvalidationActionId,
    toastSuccess, countryIWithCodeActionId
} from "../../utils/constants";
import Pagination from "../../utils/pagination";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { fill_action } from "../../actions/fillCombo_action";
import StepHeader from "./stepHeader";
import PrimaryChapter from "./primary_chapter";
import Description from "./description";
import Resizer from "react-image-file-resizer";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../utils/Validator";
import $ from "jquery";
/* 
 * mapDispatchToProps
*/
// const mapDispatchToProps = dispatch => ({
//     loginAction: () => dispatch(loginAction())
// })

/* 
 * mapStateToProps getUserHotelEnquiry_action
insertHotelEnquiry_action
*/
const mapStateToProps = state => ({
    ...state
})

class HotelEnquiryForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isDataLoad: false,
            isExibitionClosed: false,
            isregistrationLinkClosed: false,
            code: '',
            isOtherPreName: '',
            otherName: '',
            Name: '',
            NameErr: '',
            preName: 'Mr',
            companyName: '',
            companyNameErr: '',
            Email: '',
            EmailErr: '',
            mobNo: '',
            mobNoErr: '',
            preMobNo: '',
            remark: '',
            NOP: '',
            NOPErr: '',
            NOR: '',
            NORErr: '',
            checkInDate: '',
            checkOutDate: '',
            checkInDateErr: '',
            checkOutDateErr: '',
            singleOcc: '',
            doubleOcc: '',
            singleOccErr: '',
            doubleOccErr: '',
            from: '',
            exhID: '',
            EventDate: '',
            SetupDate: '',
            DismantleDate: '',
            ExhibitionAddress: '',
        }
        this.getFillList = this.getFillList.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.inputValidation = this.inputValidation.bind(this)
        this.getDetails = this.getDetails.bind(this)
        this.onCancleForm = this.onCancleForm.bind(this)

    }
    componentDidMount() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr, from } = this.state
        var tempForm = this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : ''
        this.setState({
            from: this.props.location.state != null && this.props.location.state.from ? this.props.location.state.from : null,
            exhID: this.props.location.state != null && this.props.location.state.exhID ? this.props.location.state.exhID : null,
        }, () => {
            if (tempForm == "thanks") {
                this.getFillList(countryIWithCodeActionId, '', '', '', sessionStorage.getItem("sessionCode"), '')
            }
            this.getDetails()
            window.scrollTo(0, 0);
        })
    }

    getDetails() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, EventDate, DismantleDate, SetupDate, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state        // this.setState({ isLoading: true })
        this.props
            .getUserHotelEnquiry_action(exhID) // DYNAMIC PARAMS HAS TO BE PLACE LATER <<==
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0][0])
                    var mobNo = data.data[0][0].MobileNo != '' && data.data[0][0].MobileNo != null ? data.data[0][0].MobileNo.split('-') : []
                    var preMob = mobNo.length == 2 ? mobNo[0] : ''
                    var mobNo1 = mobNo.length == 2 ? mobNo[1] : mobNo.length == 1 ? mobNo[0] : ''
                    this.setState({
                        Name: data.data[0][0].PersonIncharge,
                        companyName: data.data[0][0].CompanyName,
                        DismantleDate: data.data[0][0].DismantleDate,
                        EventDate: data.data[0][0].EventDate,
                        mobNo: mobNo1,
                        preMobNo: preMob,
                        Email: data.data[0][0].PrimaryEmail,
                        SetupDate: data.data[0][0].SetupDate,
                        ExhibitionAddress: data.data[0][0].ExhibitionAddress
                    })
                }
            }).catch(e => {
                console.log(e)
            })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === countryIWithCodeActionId) {
                        if (data.data.length > 0) {
                            console.log("country data", data.data[0])
                            console.log(data.data[0])
                            var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                            var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []

                            sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                            sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                            sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                            sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                            sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                            sessionStorage.setItem("sessionLogoPath", data.data[0]['Logo'])
                            sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                            sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                            sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                            sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])

                            this.setState({
                                isDataLoad: true,
                                isExibitionClosed: data.data[0]['IsExhibitionClosed'] != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                isregistrationLinkClosed: data.data[0]['isregistrationLinkClosed'] != null && data.data[0]['isregistrationLinkClosed'] == 1 ? true : false,
                            })
                            console.log("country data", emailArr, mobileArr, JSON.parse(sessionStorage.getItem("sessionExhibitionMobileNo")))
                            this.setState({ isLoading: false })

                        } else {
                            this.setState({ isLoading: false, invalidLink: true })
                        }

                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });

    }

    handleSubmit() {
        const { isLoading, exhID, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, checkInDate, checkInDateErr, checkOutDate, checkOutDateErr, code, NOP, NOPErr, NOR, NORErr, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, singleOcc, doubleOcc, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        this.inputValidation().then(res => {
            if (!res) {
                console.log(doubleOcc + singleOcc, NOR)
                if (NOR != (parseInt(doubleOcc) + parseInt(singleOcc))) {
                    toastError("No of rooms should be equal to sum of single occupancy and double occupancy")
                } else {
                    this.setState({ isLoading: true })
                    var finalMobNo = ''
                    if (preMobNo != '' && preMobNo != null) {
                        finalMobNo = `${preMobNo}-${mobNo}`
                    } else {
                        finalMobNo = mobNo
                    }
                    console.log(
                        Name,
                        companyName,
                        Email,
                        finalMobNo,
                        checkInDate,
                        checkOutDate,
                        NOP,
                        NOR,
                        singleOcc,
                        doubleOcc,
                        remark
                    )
                    this.props
                        .insertHotelEnquiry_action(exhID,
                            Name,
                            companyName,
                            Email,
                            finalMobNo,
                            checkInDate,
                            checkOutDate,
                            NOP,
                            NOR,
                            singleOcc,
                            doubleOcc,
                            remark)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                toastSuccess("Form Submitted Successfully")
                                setTimeout(() => {
                                    this.props.navigate(-1)
                                }, 1000);
                            }
                        }).catch((e) => {
                            console.log(e);
                        });
                }
            } else {
                toastError("Please fill mandatory fields")
            }
        })

    }

    inputValidation() {
        const { isLoading, isDataLoad, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, singleOcc, doubleOcc, NOP, NOPErr, NOR, NORErr, singleOccErr, doubleOccErr, checkInDate, checkInDateErr, checkOutDate, checkOutDateErr, code, preMobNo, tentativeDaysSetup, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, tentativeDaysEventErr, tentativePaxEvent, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        return new Promise((resolve, reject) => {
            var Errr = false
            if (companyName.trim() == '' || companyName.trim() == null) {
                this.setState({ companyNameErr: "Please Enter Organization Name" })
                Errr = true
            }
            if (Name.trim() == '' || Name.trim() == null) {
                this.setState({ NameErr: "Please Enter Name" })
                Errr = true
            }
            if (Email.trim() == '' || Email.trim() == null) {
                this.setState({ EmailErr: "Please Enter Email" })
                Errr = true
            }
            if (mobNo.trim() == '' || mobNo.trim() == null) {
                this.setState({ mobNoErr: "Please Enter Mobile" })
                Errr = true
            }
            if (checkInDate == '' || checkInDate == null) {
                this.setState({ checkInDateErr: "Please Enter CheckIn date" })
                Errr = true
            }
            if (checkOutDate == '' || checkOutDate == null) {
                this.setState({ checkOutDateErr: "Please Enter CheckOut date" })
                Errr = true
            }
            if (NOP == '' || NOP == null) {
                this.setState({ NOPErr: "Please Enter No. of Pax" })
                Errr = true
            }
            if (NOR == '' || NOR == null) {
                this.setState({ NORErr: "Please Enter No. of Rooms" })
                Errr = true
            }
            if (singleOcc == '' || singleOcc == null) {
                this.setState({ singleOccErr: "Please Enter Single Occupancy" })
                Errr = true
            }
            if (doubleOcc == '' || doubleOcc == null) {
                this.setState({ doubleOccErr: "Please Enter Double Occupancy" })
                Errr = true
            }

            resolve(Errr)
        })
    }

    preventMinus = (e) => {
        (e.keyCode === 69 || e.keyCode === 190) && e.preventDefault()
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    }


    maxLengthCheck = (object, maxLength) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }
    handlePaste = (event) => {
        const pastedValue = event.clipboardData.getData('text/plain');
        const sanitizedValue = pastedValue.replace(/[-.eE]/g, ''); // Remove '-', '.', 'e', 'E' characters

        // Replace the input value with the sanitized value
        document.execCommand('insertText', false, sanitizedValue);

        event.preventDefault(); // Prevent the default paste behavior
    }

    onCancleForm(e) {
        e.preventDefault()
        this.props.navigate(-1)
    }

    render() {
        const { isLoading, isDataLoad, singleOcc, singleOccErr, doubleOcc, doubleOccErr, invalidLink, isregistrationLinkClosed, companyNameErr, isExibitionClosed, companyName, isOtherPreName, otherName, Name, NameErr, preName, Email, EmailErr, mobNo, mobNoErr, preMobNo, checkInDate, tentativeDaysSetup, checkInDateErr, remark, tentativeDaysSetupErr, tentativePaxSetup, tentativePaxSetupErr, tentativeDaysEvent, checkOutDate, checkOutDateErr, tentativeDaysEventErr, SetupDate, EventDate, DismantleDate, ExhibitionAddress, from, tentativePaxEvent, NOP, NOPErr, NOR, NORErr, tentativePaxEventErr, NORSetup, NOREvent, NORSetupErr, NOREventErr } = this.state
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <ToastContainer />
                <>
                    {/* PAGE */}
                    <div className="page">
                        <div className="page-main">
                            {from == 'dashboard' ? <ExhibitorHeader /> : isDataLoad ? <HeaderLogin /> : null}
                            {from == 'dashboard' ? <ExhibitorDrawer /> : null}

                            {/*app-content open*/}
                            <div className={from == 'dashboard' ? "main-content  with-dr-container" : 'main-content app-content mt-0'}>
                                <div className="side-app">
                                    <>
                                        {!false ? (
                                            <>
                                                <div className="main-container container-fluid  mt-top-space" style={{ marginTop: '6rem' }}>
                                                    <div className="row p-1">
                                                        <h3 className="text-center" style={{ fontWeight: 700, fontSize: '30px' }}>
                                                            HOTEL ENQUIRY FORM FOR INDIA ITME 2026
                                                        </h3>
                                                    </div>
                                                    <div className="row p-1 mt-3">
                                                        <p><strong>Setup Date - </strong> {SetupDate != '' && SetupDate != null ? SetupDate : ''}</p>
                                                        <p><strong>Event Date -</strong> {EventDate != '' && EventDate != null ? EventDate : ''}</p>
                                                        <p><strong>Dismantle Date -</strong> {DismantleDate != '' && DismantleDate != null ? DismantleDate : ''}</p>
                                                        <p><strong>Venue -</strong>  {ExhibitionAddress != '' && ExhibitionAddress != null ? ExhibitionAddress : ''}</p>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xl-6 mt-3">
                                                            <label>
                                                                Name<span className="text-red">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                maxLength={'50'}
                                                                value={Name}
                                                                onChange={(e) => this.setState({ Name: e.target.value, NameErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{NameErr}</span>}
                                                        </div>
                                                        <div className="col-xl-6 ">
                                                            <label className="mt-3">Organization<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={companyName}
                                                                maxLength={'200'}
                                                                onChange={(e) => this.setState({ companyName: e.target.value, companyNameErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{companyNameErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-xl-6 mt-2">
                                                            <label className="mt-3">Email<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={Email}
                                                                maxLength={'200'}
                                                                onChange={(e) => this.setState({ Email: e.target.value, EmailErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{EmailErr}</span>}
                                                        </div>
                                                        <div className="col-xl-6 mt-3">
                                                            <label className="d-flex mt-2">Mobile No
                                                                <span className="rad-star text-danger">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={mobNo}
                                                                maxLength={'10'}
                                                                onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                style={{ paddingLeft: 50 }}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ mobNo: e.target.value, mobNoErr: "" }) : null}
                                                            />
                                                            <input
                                                                type="text"
                                                                className="form-control-1"
                                                                placeholder="ISD"
                                                                maxLength={'10'}
                                                                value={preMobNo}
                                                                onChange={(e) => this.setState({ preMobNo: e.target.value })}
                                                                style={{
                                                                    width: 45,
                                                                    position: "absolute",
                                                                    top: 30,
                                                                    padding: " 6px !important",
                                                                    paddingLeft: 5,
                                                                    borderLeft: 0,
                                                                    borderTop: 0,
                                                                    background: "none",
                                                                    borderBottom: 0,
                                                                    height: 34
                                                                }}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{mobNoErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{ marginTop: '30px' }}>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Tentative   Check In Date<span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker
                                                                style={{ zIndex: '99999' }}
                                                                selected={checkInDate}
                                                                dateFormat={"dd/MM/yyyy"}
                                                                className="form-control"
                                                                onChange={(date) => this.setState({ checkInDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), checkInDateErr: "" })}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                            // placeholderText="Date"
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{checkInDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label htmlFor="validationCustom03">
                                                                Tentative Check Out Date<span className="text-red">*</span>
                                                            </label>
                                                            <DatePicker
                                                                style={{ zIndex: '99999' }}
                                                                selected={checkOutDate}
                                                                dateFormat={"dd/MM/yyyy"}
                                                                className="form-control"
                                                                onChange={(date) => this.setState({ checkOutDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), checkOutDateErr: "" })}
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                            // placeholderText="Date"
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{checkOutDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="">Tentative No. of  Pax<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={NOP}
                                                                maxLength={'200'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ NOP: e.target.value, NOPErr: "" }) : null}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{NOPErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{ marginTop: '30px' }}>
                                                        <div className="col-xl-3">
                                                            <label className="">Tentative No. of Rooms<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={NOR}
                                                                maxLength={'200'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ NOR: e.target.value, NORErr: "" }) : null}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{NORErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="">No. of Single Occupancy Rooms<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={singleOcc}
                                                                maxLength={'200'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ singleOcc: e.target.value, singleOccErr: "", doubleOcc: NOR != '' && NOR != null ? (NOR - e.target.value) >= 0 ? NOR - e.target.value : '' : doubleOcc, doubleOccErr: NOR != '' && NOR != null ? (NOR - e.target.value) >= 0 ? "" : doubleOccErr : doubleOccErr }) : null}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{singleOccErr}</span>}
                                                        </div>
                                                        <div className="col-xl-3">
                                                            <label className="">No. of Double Occupancy Rooms<span className="text-red">*</span></label>
                                                            <input type="text" className="form-control" value={doubleOcc}
                                                                maxLength={'200'}
                                                                onKeyDown={(e) => this.preventMinus(e)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onWheel={(e) => e.target.blur()}
                                                                onChange={(e) => /^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?$/.test(e.target.value) || e.target.value == '' ? this.setState({ doubleOcc: e.target.value, doubleOccErr: "", singleOcc: NOR != '' && NOR != null ? (NOR - e.target.value) >= 0 ? NOR - e.target.value : '' : singleOcc, singleOccErr: NOR != '' && NOR != null ? (NOR - e.target.value) >= 0 ? "" : singleOccErr : singleOccErr }) : null}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block'>{doubleOccErr}</span>}
                                                        </div>
                                                    </div>
                                                    <div className="row" style={{ marginTop: '30px' }}>
                                                        <div className="col-xl-9">
                                                            <label>Comment</label>
                                                            <textarea value={remark} style={{height:'150px'}} className="form-control" onChange={(e) => this.setState({ remark: e.target.value })}>

                                                            </textarea>
                                                        </div>
                                                    </div>
                                                    <div className="" style={{ marginTop: '30px' }}>
                                                        <button type="button" class="btn btn-primary rounded-0 m-2 mt-3"
                                                            onClick={(e) => this.handleSubmit()}
                                                        >
                                                            Submit
                                                        </button>
                                                        <button type="button" class="btn btn-danger rounded-0 m-2 mt-3"
                                                            onClick={(e) => this.onCancleForm(e)}
                                                        >
                                                            Back
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div
                                                className="main-content app-content mt-0"
                                                style={{ backgroundColor: "#ececec" }}
                                            >
                                                <div className="side-app">
                                                    <div className="main-container container-fluid top-form-name">
                                                        <div className="row ">
                                                            <form className="needs-validation " noValidate="">
                                                                <div className="form-row mt-4">
                                                                    <div className="form-group col-md-7 p-4 thank-box">
                                                                        <div className="form-group mb-2">
                                                                            <h4
                                                                                className="mb-0 pt-2 pb-4 thank-top-mes"
                                                                                style={{ color: "#318958" }}
                                                                            >
                                                                                <strong>Exhibition Closed</strong>
                                                                            </h4>
                                                                            <p className="mb-1 mt-1 text-center com-font">
                                                                                Thank you for your interest but the
                                                                            </p>
                                                                            <p className="mt-1 mb-0 text-center com-font">
                                                                                {sessionStorage.getItem("sessionExhibitionName")} from {moment(sessionStorage.getItem("exhibitionDateFrom")).format("DD MMMM YYYY")} to {moment(sessionStorage.getItem("exhibitionDateTo")).format("DD MMMM YYYY")}
                                                                            </p>
                                                                            <p className="mb-3 text-center com-font">
                                                                                at {sessionStorage.getItem("exhibitionAddress")} is now closed.
                                                                            </p>
                                                                            <p className="mb-3 text-center com-font">
                                                                                This Event already completed. Please Visit Again once the next edition is announced.
                                                                            </p>
                                                                        </div>
                                                                        <div classname="">
                                                                            <div classname="mt-1 mb-4">

                                                                                <button
                                                                                    classname="btn btn-next-bot m-1"
                                                                                    style={{
                                                                                        background: "#007bff",
                                                                                        padding: "6px 20px",
                                                                                        fontSize: 14,
                                                                                        border: "1px solid #007bff",
                                                                                        borderRadius: 2,
                                                                                        color: "#fff",
                                                                                        marginTop: 16
                                                                                    }}
                                                                                    onClick={e => this.onPreviousClick(e)}
                                                                                >
                                                                                    {" "}
                                                                                    BACK TO EVENT WEBSITE
                                                                                </button>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </>
        )
    }

}


export default withRouter(connect(null, {
    fill_action, getUserHotelEnquiry_action,
    insertHotelEnquiry_action
})(HotelEnquiryForm));